import { addW2, normalize, sub } from "@thi.ng/vectors";
export const quadraticTangentAt = (out, a, b, c, t, len = 1) => normalize(out, addW2(out, sub(out, b, a), sub([], c, b), 2 * (1 - t), 2 * t), len);
